<h2>Plan N’Go - Modification concession</h2>
<div class="wrapper" style="width: 750px !important;">
  <form>

    <div class="form-group mt-3" style="width: 600px">
      <label for="uniqid" matTooltip="Réception autonome">Identifiant unique :</label>
      <input [(ngModel)]="dealershipInformations.uniqid" class="form-control" id="uniqid" name="uniqid">
    </div>

    <div class="form-group mt-3" style="width: 600px">
      <label for="external_group_id" matTooltip="Soft-net">Identifiant groupe :</label>
      <input [(ngModel)]="dealershipInformations.external_group_id" class="form-control" id="external_group_id" name="external_group_id">
    </div>

    <div class="form-group mt-3" style="width: 600px">
      <label for="external_branch_id" matTooltip="Soft-net">Identifiant branche :</label>
      <input [(ngModel)]="dealershipInformations.external_branch_id" class="form-control" id="external_branch_id" name="external_branch_id">
    </div>

    <div class="form-row mt-3">
      <div class="form-group col-md-4">
        <label for="opening_time">Heure d'ouverture :</label>
        <input [(ngModel)]="dealershipInformations.opening_time" class="form-control" id="opening_time" name="opening_time" type="time" required>
      </div>
      <div class="form-group col-md-4">
        <label for="lunch_break_start">Début de la pause méridienne :</label>
        <input [(ngModel)]="dealershipInformations.lunch_break_start" class="form-control" id="lunch_break_start" name="lunch_break_start" type="time" required>
      </div>
    </div>
    <div class="form-row mt-3">
      <div class="form-group col-md-4">
        <label for="lunch_break_end">Fin de la pause méridienne :</label>
        <input [(ngModel)]="dealershipInformations.lunch_break_end" class="form-control" id="lunch_break_end" name="lunch_break_end" type="time" required>
      </div>
      <div class="form-group col-md-4">
        <label for="closing_time">Heure de fermeture :</label>
        <input [(ngModel)]="dealershipInformations.closing_time" class="form-control" id="closing_time" name="closing_time" type="time" required>
      </div>
    </div>

    <div class="form-row mt-3">
      <div class="form-group col-md-3 d-flex align-items-center">
        <label>Concession active :</label>
        <mat-checkbox class="ml-2" (change)="changeBoolValue('active')" [checked]="dealershipInformations.active"></mat-checkbox>
      </div>

      <div class="form-group col-md-3 d-flex align-items-center">
        <label matTooltip="Scénario 24VT">Concession temporaire :</label>
        <mat-checkbox class="ml-2" (change)="changeBoolValue('dealership_temp')" [checked]="dealershipInformations.dealership_temp"></mat-checkbox>
      </div>

      <div class="form-group col-md-3 d-flex align-items-center">
        <label>Concession ouverte le samedi :</label>
        <mat-checkbox class="ml-2" (change)="changeBoolValue('open_on_saturday')" [checked]="dealershipInformations.open_on_saturday"></mat-checkbox>
      </div>
    </div>

    <div class="btn-group mt-3 mb-5">
      <div>
        <button (click)="updateDealershipInformations()" class="btn btn100px btn-dark p-2 mr-2" [disabled]="dealershipInformations.opening_time == '' || dealershipInformations.lunch_break_start == '' || dealershipInformations.lunch_break_end == '' || dealershipInformations.closing_time == ''">Modifier</button>
      </div>

      <div>
        <button (click)="onCancelClick()" class="btn btn-light btn100px border-dark p-2">Annuler</button>
      </div>
    </div>
  </form>
</div>
